import { render } from "./TheTooltip.vue?vue&type=template&id=2f16c297"
import script from "./TheTooltip.vue?vue&type=script&lang=js"
export * from "./TheTooltip.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__